import Button from '@blocks/Button'
import Flex from '@blocks/Flex'
import Grid from '@blocks/Grid'
import { percent } from '@helpers'
import { desktop } from '@styles/mixins'
import React, { useState } from 'react'
import styled, { css } from 'styled-components'
import Fade from 'react-reveal/Fade'
import { useSalonGalleryContext } from '../../../context'

export default function SalonGallerySection({ last, ...section }: General.Resources.SalonSection & { last: boolean }) {
    const { salon } = useSalonGalleryContext()
    const [awards, setAwards] = useState<Resources.Award[]>(section.awards.slice(0, 3))
    const [visible, setVisible] = useState(section.awards.length < 4)

    const toggleVisibility = () => {
        setAwards(
            visible 
                ? section.awards.slice(0, 3) 
                : section.awards
        )

        setVisible(!visible)
    }

    return (
        <ComponentContainer>
            <GridInfo>
                <Grid gap="10px">
                    <h3>{section.name}</h3>
                    <Grid gap="10px">
                        <Grid gap="0px">
                            <small>Received: </small>
                            <p><b>{section.participations_count} images</b></p>
                        </Grid>
                        <Grid gap="0px">
                            <small>Accepted: </small>
                            <p><b>{section.acceptances_count} images ({percent(section.acceptances_count, section.participations_count)})</b></p>
                        </Grid>
                        <Grid gap="0px">
                            <small>Acceptance score: </small>
                            <p><b>{section.limit} out of {salon.attrs.maxScore()}</b></p>
                        </Grid>
                    </Grid>
                </Grid>
            </GridInfo>
            <GridAwards>
                <Grid gap="30px|45px">
                    {awards.map((participation, idx) => (
                        <Fade key={idx}>
                            <PhotoContainer>
                                <Grid gap="15px">
                                    <img src={participation.url}></img>
                                    <Grid gap="5px">
                                        <h4>{participation.name}</h4>
                                        <p>{participation.award}</p>
                                    </Grid>
                                </Grid>
                            </PhotoContainer>
                        </Fade>
                    ))}
                </Grid>
            </GridAwards>
            {(!visible || !last) && (
                <GridMore>
                    <Grid gap="5px">
                        <hr />
                        {!visible && (
                            <Flex justifyContent="space-between" alignItems="center">
                                <small>3 awards out of {section.awards.length}</small>
                                <Button type="tertiary" onClick={toggleVisibility}>See More</Button>
                            </Flex>
                        )}
                    </Grid>
                </GridMore>
            )}
        </ComponentContainer>
    )
}

const ComponentContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto auto auto;
    grid-template-areas: 
        'info'
        'awards'
        'more';
    grid-gap: 30px;
    align-items: start;
    
    ${desktop(css`
        grid-template-columns: minmax(300px, 33%) 1fr;
        grid-template-rows: auto auto;
        grid-template-areas: 
            'info awards'
            'more more';
    `)}
`

const GridInfo = styled.div`
    grid-area: info;
`

const GridMore = styled.div`
    grid-area: more;
`

const GridAwards = styled.div`
    grid-area: awards;
`

const PhotoContainer = styled.div`
    img {
        max-width: 100%;
        max-height: 80vh;
    }
`